import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useChangeTransitionState } from 'util/react-transition-component/hooks/useChangeTransitionState';
import { useTransitionController } from 'util/react-transition-component';
import { useGlobalStore } from '../../../../stores/global';
import styles from './HamburgerButton.module.scss';
import {
  setupTransitionInTimeline,
  setupTransitionOutTimeline,
} from './HamburgerButton.transitions';
import type { HamburgerButtonProps } from './HamburgerButton.data';

export default observer(({ isVisible, className, ref }: HamburgerButtonProps): ReactElement => {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLButtonElement | null>;
  const store = useGlobalStore();
  const { menuIsOpen, toggleMenuOpenState } = store;

  const transitionController = useTransitionController(
    () => ({
      ref: elementRef,
      refs: {
        elementRef,
      },
      setupTransitionInTimeline,
      setupTransitionOutTimeline,
    }),
    [],
  );

  useChangeTransitionState(transitionController, isVisible);

  return (
    <button
      type="button"
      aria-label="click to toggle menu"
      onClick={toggleMenuOpenState?.bind(store)}
      ref={elementRef}
      className={classNames(styles.hamburgerButton, className, 'button', {
        [styles.isOpen]: menuIsOpen,
      })}
    >
      <div className={classNames(styles.icon)} />
    </button>
  );
});
